import { ReferralSummary } from '../../../../models/referral/referral.model';
import {
  SummaryCard,
  SummaryGrid,
  SummaryLabel,
  SummaryValue,
} from '../Referral.styles';

interface ReferralSummaryMetricsProps {
  summary: ReferralSummary | null;
}

const ReferralSummaryMetrics: React.FC<ReferralSummaryMetricsProps> = ({
  summary,
}) => {
  const metrics = [
    {
      label: 'Referral Points',
      value: summary?.points ?? 0,
    },
    {
      label: 'Total Referrals',
      value: summary?.referralCount ?? 0,
    },
    {
      label: 'Qualified Referrals',
      value: summary?.qualifiedReferralCount ?? 0,
    },
    {
      label: 'Pending Referrals',
      value: summary?.pendingReferralCount ?? 0,
    },
  ];

  return (
    <SummaryGrid>
      {metrics.map((metric) => (
        <SummaryCard key={metric.label}>
          <SummaryLabel>{metric.label}</SummaryLabel>
          <SummaryValue>{metric.value}</SummaryValue>
        </SummaryCard>
      ))}
    </SummaryGrid>
  );
};

export default ReferralSummaryMetrics;
